import * as React from 'react';
import classNames from 'classnames';

import * as style from './HeaderButton.css';

export interface IHeaderButtonProps {
  type: 'l' | 'xs';
  onClick: () => void;
  dataTestId?: string;
}

export const HeaderButton = ({ type, onClick, children, dataTestId }: React.PropsWithChildren<IHeaderButtonProps>) => {
  const handleClick = React.useCallback(
    (e: React.SyntheticEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <button
      type="button"
      onClick={handleClick}
      className={classNames(style['container'], style[`container--${type}`])}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};
